// extracted by mini-css-extract-plugin
module.exports = {"settingsSubscriptionsPage":"SettingsSubscription_settingsSubscriptionsPage__mOz34","plansContainer":"SettingsSubscription_plansContainer__k7aXa"};